import { ActionError, Button } from '@westhetics/ui'
import { errorMessage, errorRequestId } from '@/lib/errors'

/**
 * O estado "com erro" de uma tela que não conseguiu carregar: o que falhou, por quê e a saída.
 * Fica na tela até a pessoa tentar de novo (docs/styleguide/05-arquetipos.md, "Os quatro estados").
 */
export function LoadError({
  title,
  error,
  onRetry,
  className,
}: {
  title: string
  error: unknown
  onRetry: () => void
  className?: string
}) {
  const requestId = errorRequestId(error)
  return (
    <ActionError
      className={className}
      title={title}
      description={
        <>
          {errorMessage(error)}
          {requestId ? (
            <span className="text-label"> Se precisar reportar, informe o código {requestId}.</span>
          ) : null}
        </>
      }
      actions={
        <Button variant="outline" size="sm" onClick={onRetry}>
          Tentar de novo
        </Button>
      }
    />
  )
}
